import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from "@angular/core";
import { NgxEchartsModule } from "ngx-echarts";
import * as echarts from "echarts";

@Component({
  selector: "uptime-charts",
  templateUrl: "./uptime-chart.component.html",
  styleUrls: ["./uptime-chart.component.scss"],
  standalone: true,
  imports: [NgxEchartsModule, CommonModule],
})
export class UptimeChartsComponent implements OnChanges, OnDestroy {
  @Input() series: any[] = [];
  @Input() name: string = "";

  chartOption: any = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["series"]) {
      this.updateChart();
    }

    if (changes["name"]) {
      this.updateChart();
    }
  }

  private cleanSeries(series: any[]) {
    return series.map((s) => ({
      name: s.name,
      type: "line",
      smooth: true,
      data: (s.data || []).map((p) => {
        const y = parseFloat(p.y);
        return [
          p.x,
          isNaN(y) ? null : y, // avoid NaN
        ];
      }),
    }));
  }

  private updateChart() {
    const seriesData =
      this.series && this.series.length
        ? this.cleanSeries(this.series)
        : [{ name: "No Data", type: "line", data: [] }];

    this.chartOption = {
      stroke: {
        curve: "smooth", // keeps the line smooth
        width: 4, // increase this value for thicker lines
      },
      markers: {
        size: 6,
        strokeWidth: 3,
        strokeColors: "#000",
        hover: {
          size: 8,
          sizeOffset: 3,
        },
      },
      colors: [
        "#008FFB",
        "#00E396",
        "#FEB019",
        "#FF4560",
        "#775DD0",
        "#546E7A",
        "#26a69a",
        "#D10CE8",
        "#F86624",
      ],
      title: {
        text: this.name || "",
        left: "center",
      },
      legend: {
        top: 30,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
        },
      },
      toolbox: {
        feature: {
          saveAsImage: {},
          dataZoom: {},
          restore: {},
          magicType: { type: ["line", "bar", "stack", "tiled", "area"] },
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "time",
        axisLabel: { formatter: "{yyyy}-{MM}-{dd} {HH}:{mm}" },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 100,
        axisLabel: { formatter: "{value}%" },
      },
      series: seriesData.map((s) => ({
        ...s,
        lineStyle: {
          width: 4, // ✅ This makes lines thicker
        },
        // areaStyle: {},
        symbolSize: 8, // ✅ Bigger markers
        itemStyle: {
          borderWidth: 2, // Bold outline for markers
        },
        markArea: {
          silent: true,
          itemStyle: {},
          data: [
            [
              { yAxis: 0, itemStyle: { color: "rgba(255,0,0,0.2)" } },
              { yAxis: 90 },
            ],
            [
              { yAxis: 90, itemStyle: { color: "rgba(255,255,0,0.2)" } },
              { yAxis: 95 },
            ],
            [
              { yAxis: 95, itemStyle: { color: "rgba(0,255,0,0.2)" } },
              { yAxis: 100 },
            ],
          ],
        },
      })),
    };
  }

  ngOnDestroy(): void {}
}
